import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPage } from "../lib/analytics";

/**
 * Fires an `analytics_events` page_view every time the route changes.
 * Mount once inside <BrowserRouter>.
 */
export default function AnalyticsTracker() {
    const location = useLocation();
    useEffect(() => {
        trackPage(location.pathname);
    }, [location.pathname]);
    return null;
}
